export const RELATIONSHIP = [
  '자녀',
  '배우자',
  '아버지',
  '어머니',
  '시아버지',
  '시어머니',
  '장인어른',
  '장모님',
  '형제/자매',
  '며느리',
  '사위',
  '기타',
];

export const ERROR_MESSAGE = {
  tel: '연락처가 정확한지 확인해 주세요.',
};
